import React,{Component} from "react";

import './OpacityRange.css'

export class OpacityRange extends Component {
    constructor(props) {
        super(props);

        this.state = {
            opacity: 100
        }

    }

    componentDidMount() {
        IsNumber(this.props.value) && this.setState({
            opacity: this.props.value
        });
    }

    render() {
        return (
            <div className="opacityRange">
                <input type="range" id="opacityInput" min="0" max="100" step="5" value={this.state.opacity.toFixed(0)} 
                onChange={this.handleChangeValue}
                style={{ backgroundSize: `${3 + this.state.opacity * 0.94}% 100%` }}/>
                <span>不透明:{this.state.opacity}%</span>
            </div>

        );
    }

    handleChangeValue=(event) => {
        this.setState({
            opacity: Number(event.currentTarget.value)
        })
        this.props.handleChangeValue && this.props.handleChangeValue(event);
    }
}